function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 7C23.299 7 28 11.701 28 17.5C28 23.299 23.299 28 17.5 28C11.701 28 7 23.299 7 17.5C7 11.701 11.701 7 17.5 7Z",
  fill: "white",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8258 4.82489C13.83 5.69528 15.8052 7.70386 16.9768 10.9176C18.0146 13.83 17.8472 16.3408 17.6798 17.6464C16.709 16.776 14.9013 15.0017 13.7631 12.1562C12.491 8.97596 12.6584 6.16395 12.8258 4.85837V4.82489Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3039 5.15966C23.4043 6.46524 23.4043 9.31073 21.9313 12.3906C20.5923 15.1691 18.7176 16.8429 17.6798 17.6464C17.5794 16.3408 17.6129 13.83 18.818 10.9845C20.1571 7.83777 22.2996 5.96309 23.3373 5.15966H23.3039Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.4678 12.8258C29.5974 13.83 27.5888 15.8052 24.3751 16.9768C21.4627 18.0146 18.9519 17.8472 17.6464 17.6798C18.5167 16.709 20.291 14.9013 23.1365 13.7631C26.3167 12.491 29.1288 12.6584 30.4343 12.8258H30.4678Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.1331 23.3039C28.8275 23.4043 25.982 23.4043 22.9021 21.9313C20.1236 20.5923 18.4498 18.7176 17.6464 17.6798C18.9519 17.5794 21.4627 17.6129 24.3082 18.818C27.4549 20.1571 29.3296 22.2996 30.1331 23.3373V23.3039Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5004 30.4678C21.4961 29.5974 19.521 27.5888 18.3494 24.3751C17.3116 21.4627 17.479 18.9519 17.6464 17.6464C18.6172 18.5167 20.4249 20.291 21.5631 23.1365C22.8352 26.3167 22.6678 29.1288 22.5004 30.4343V30.4678Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0223 30.133C11.9219 28.8275 11.9219 25.982 13.3948 22.9021C14.7339 20.1236 16.6086 18.4498 17.6463 17.6464C17.7468 18.9519 17.7133 21.4627 16.5082 24.3082C15.1691 27.4549 13.0266 29.3296 11.9888 30.133H12.0223Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M4.82489 22.5004C5.69528 21.4961 7.70386 19.521 10.9176 18.3494C13.83 17.3116 16.3408 17.479 17.6463 17.6464C16.776 18.6172 15.0017 20.4249 12.1562 21.5631C8.97596 22.8352 6.16395 22.6678 4.85837 22.5004H4.82489Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M5.15965 12.0223C6.46523 11.9219 9.31073 11.9219 12.3906 13.3949C15.1691 14.7339 16.8429 16.6086 17.6463 17.6464C16.3408 17.7468 13.83 17.7133 10.9845 16.5082C7.83776 15.1691 5.96309 13.0266 5.15965 11.9888V12.0223Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M18 1C18.7129 2.46237 20.0817 5.63083 19.9962 9.89606C19.9106 13.7043 18.7129 16.5681 18 18C17.2871 16.5681 16.0895 13.7043 16.0039 9.89606C15.9184 5.63083 17.2586 2.46237 18 1Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8361 4.45665C30.3004 6.19743 28.9614 9.7794 25.5803 13.0266C22.5674 15.9391 19.3537 17.1442 17.6464 17.6798C18.1485 15.9725 19.3871 12.7588 22.2996 9.74592C25.5468 6.36481 29.1288 5.02575 30.8695 4.49013L30.8361 4.45665Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M34 18C32.6237 18.7129 29.6416 20.0817 25.6272 19.9962C22.043 19.9106 19.3477 18.7129 18 18C19.3477 17.2871 22.043 16.0895 25.6272 16.0039C29.6416 15.9184 32.6237 17.2586 34 18Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8361 30.8361C29.0953 30.3004 25.5133 28.9614 22.2661 25.5803C19.3536 22.5674 18.1485 19.3536 17.6129 17.6464C19.3202 18.1485 22.5339 19.3871 25.5468 22.2996C28.9279 25.5468 30.267 29.1288 30.8026 30.8695L30.8361 30.8361Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M18 34C17.2871 32.6237 15.9183 29.6416 16.0038 25.6272C16.0894 22.043 17.2871 19.3477 18 18C18.7129 19.3477 19.9105 22.043 19.9961 25.6272C20.0816 29.6416 18.7414 32.6237 18 34Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M4.45665 30.8361C4.99227 29.0953 6.33133 25.5133 9.71244 22.2661C12.7253 19.3536 15.9391 18.1485 17.6463 17.6129C17.1442 19.3202 15.9056 22.5339 12.9931 25.5468C9.74592 28.9279 6.16394 30.267 4.42317 30.8026L4.45665 30.8361Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M1 18C2.46237 17.2871 5.63083 15.9183 9.89606 16.0038C13.7043 16.0894 16.5681 17.2871 18 18C16.5681 18.7129 13.7043 19.9105 9.89606 19.9961C5.63083 20.0816 2.46237 18.7414 1 18Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M4.45665 4.45665C6.19742 4.99227 9.7794 6.33133 13.0266 9.71245C15.9391 12.7253 17.1442 15.9391 17.6798 17.6464C15.9725 17.1442 12.7588 15.9056 9.74592 12.9931C6.3648 9.74592 5.02575 6.16395 4.49013 4.42318L4.45665 4.45665Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var SvgTree = function SvgTree(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTree, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tree.6f5b1a88.svg";
export { ForwardRef as ReactComponent };